// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37uiW","inner":"styles_inner__O9ObB","right":"styles_right__1ZDWp","close":"styles_close__2UC7T","footer":"styles_footer__3BpUp"};